import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { Toaster } from '@/components/ui/sonner'
import { startApp, ProblemScreen } from './native'

const root = ReactDOM.createRoot(document.getElementById('root'))
// Website: renders at once, as before. Android staff app: after the app runtime has started (native/index.js).
startApp(
    () => root.render(
        <>
            <App />
            <Toaster position="top-right" richColors />
        </>
    ),
    (message) => root.render(<ProblemScreen message={message} />)
)
